package org.mkui.rubberband

import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.common.selection.SimpleSingleSelection
import org.mkui.geom.Curve.Companion.round
import org.mkui.geom.Rectangle
import org.mkui.geom.Rectangle2D

class SimpleRubberBand : RubberBand {
    override val rubberBand: MutableSingleSelection<Rectangle2D?> = SimpleSingleSelection()

    /**
     * {@inheritDoc}
     */
    override fun startRubberBand(x: Int, y: Int) {
        val xWorld = x.toDouble()
        val yWorld = y.toDouble()
        rubberBand.selected = Rectangle2D.Double(xWorld, yWorld, 0.0, 0.0)
    }

    /**
     * {@inheritDoc}
     */
    override fun stretchRubberBand(x: Int, y: Int) {
        if (rubberBand.isActive) {
            val xWorld = x.toDouble()
            val yWorld = y.toDouble()
            val r: Rectangle2D = rubberBand.selected!!
            rubberBand.selected = Rectangle2D.Double(r.x, r.y, xWorld - r.x, yWorld - r.y)
        }
    }

    /**
     * {@inheritDoc}
     */
    override fun stopRubberBand() {
        rubberBand.clearSelection()
    }

    /**
     * {@inheritDoc}
     */
    override val rubberBandScreen: Rectangle2D?
        get() = if (rubberBand.isActive) {
            worldToScreen(rubberBand.selected!!).normalize()
        } else {
            null
        }

    /**
     * {@inheritDoc}
     */
    fun worldToScreen(r: Rectangle2D): Rectangle2D {
        val x1 = round(r.minX).toInt()
        val x2 = round(r.maxX).toInt()
        val y1 = round(r.minY).toInt()
        val y2 = round(r.maxY).toInt()
        val width = x2 - x1
        val height = y2 - y1
        return Rectangle(x1, y1, width, height)
    }
}
